import { CategoryIconType } from "./svgicon"

export const categoryIconId = (category: string): CategoryIconType | undefined => {
  switch (category) {
    case 'Dairy and cheese':
      return 'category-dairy'
    case 'Dry goods':
      return 'category-grains'
    case 'Fish':
      return 'category-fish'
    case 'Fruits':
      return 'category-fruit'
    case 'Game':
      return 'category-game'
    case 'Herbs and flowers':
      return 'category-flower'
    case 'Meat':
      return 'category-meat'
    case 'Mushrooms':
      return 'category-mushroom'
    case 'Nuts and dried foods':
      return 'category-peanut'
    case 'Seafood':
      return 'category-shellfish'
    case 'Seaweed and sea vegetables':
      return 'category-seaweed'
    case 'Poultry':
    case 'Birds':
      return 'category-poultry'
    case 'Vegetables':
      return 'category-vegetable'
  }
}
